import { useEffect, useState, useRef } from 'react';

export const useVisibility = <T>(callback: (visible: boolean, index?: T) => void, index?: T): [React.MutableRefObject<HTMLDivElement>, boolean] => {
  const elementRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const elem = elementRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            callback(true, index);
          } else {
            setIsVisible(false);
            callback(false, index);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (elem) {
      observer.observe(elem);
    }

    return () => {
      if (elem) {
        observer.unobserve(elem);
      }
    };
  }, [callback, index]);

  return [elementRef, isVisible];
};
